import { getGlobalEventMergeId } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';
import { benefitEvents } from '@otto-ec/nexus-registry/benefit/events';

export type PriceChangeEvent = {
    newPriceCents: number;
};

export class PriceComponent extends BaseComponent {
    public rootSelector = '.js_pdp_price';

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const variationId = this.getRootElement().dataset.variationId || '';
        this.registerOnFT9BenefitEvent();
        this.renderBenefitComponent(variationId);
    }

    private renderBenefitComponent(variationId: string): void {
        const isSoldOut = this.getRootElement().dataset.isSoldOut === 'true';
        if (isSoldOut) return;

        const benefitTargetElement = this.getChildElement('.js_pdp_price__benefit-target');
        const productId = this.getRootElement().dataset.productId || '';
        const eventMergeIdAttribute = o_product.state.isVariationChanged ? `event-merge-id="${getGlobalEventMergeId()}"` : '';
        const benefitIdAttribute = benefitTargetElement.dataset.benefitId ? `benefit-id="${benefitTargetElement.dataset.benefitId}"` : '';
        benefitTargetElement.innerHTML = `<ft9-detailview-v1 team="ft5" feature="pdpDetailview" variation-id="${variationId}" product-id="${productId}" ${benefitIdAttribute} ${eventMergeIdAttribute} add-padding></ft9-detailview-v1>`;
    }

    private registerOnFT9BenefitEvent(): void {
        benefitEvents.active.subscribe(benefit => {
            const benefitElements = this.getChildElements('.js_pdp_price__discount [data-benefit-id], .js_pdp_price__tag[data-benefit-id]');
            const originalPriceElement = Array.from(benefitElements).find(element => element.dataset.benefitId === 'original')!;
            const highlightedTextElement = document.querySelector('.js_pdp_price__discount-highlight');
            let hasActiveBenefits = false;

            benefitElements.forEach(element => {
                const benefitId = element.dataset.benefitId;
                if (benefitId === benefit.id && benefit.active) {
                    element.classList.remove('pl_hidden');
                    originalPriceElement.classList.add('pl_hidden');
                    highlightedTextElement?.classList.add('pdp_price__discount-highlight--sale');
                    this.removeInstallments(benefitId);
                    hasActiveBenefits = true;
                } else {
                    element.classList.add('pl_hidden');
                }
            });

            if (!hasActiveBenefits) {
                originalPriceElement.classList.remove('pl_hidden');
            }

            this.notifyPriceChanged();
        });
    }

    private notifyPriceChanged(): void {
        const newPrice = this.getRootElement().querySelector<HTMLElement>('.js_pdp_price__tag:not(.pl_hidden)')?.dataset.priceCents;

        if (newPrice) {
            const event: PriceChangeEvent = {
                newPriceCents: Number(newPrice),
            };

            o_global.eventQBus.emit('ft5.variation.price.change', event);
        }
    }

    private removeInstallments(benefitId: string): void {
        const priceElem = document.querySelector<HTMLElement>(`.js_pdp_price__retail-price__value_${benefitId}`);
        if (priceElem && priceElem.innerHTML === '0,00&nbsp;€') {
            const installmentWrapper = document.querySelector('.js_pdp_price__installment-wrapper');
            installmentWrapper && installmentWrapper.classList.add('pl_hidden');
        }
    }
}
